import {
  App as AntdAppBit,
  ConfigProvider as ConfigProviderBit,
  FloatButton
} from '@bit-design/react'
import { Outlet } from '@bit/zeus-ssr/router'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import minMax from 'dayjs/plugin/minMax'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import 'dayjs/locale/zh-cn'
import 'src/style/global.css'

import { SUPPORT_LOCALES } from '@bit/utils'
import { Helmet } from '@bit/zeus-ssr/components'
import React, { useEffect, useMemo } from 'react'

import { Resource } from 'src/components/base/Resource'
import { useDeviceInfo } from 'src/hook/biz/useDeviceInfo'
import { useFastDomain } from 'src/hook/biz/useFastDomain'

import { SeoTdk } from './components/base/SeoTdk'
import { GlobalModal } from './components/biz/GlobalModal'
import { useTitleBarTheme } from './hook/base/useTitleBarTheme'
import { useAntdLocale } from './hook/biz/useAntdLocale'
import { useRouter } from './hook/biz/useRouter'
import { monitor } from './util/monitor/initMonitor'

dayjs.extend(isBetween)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(minMax)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.tz.setDefault('Asia/Shanghai')

const App: React.FC = () => {
  useDeviceInfo()

  useFastDomain()

  const router = useRouter()

  const antdLocale = useAntdLocale()

  const dir = useMemo(() => {
    if (router.locale === SUPPORT_LOCALES.Ar) {
      return 'rtl'
    }

    return 'ltr'
  }, [router.locale])

  useTitleBarTheme()

  useEffect(() => {
    monitor?.updateConfig({ lang: router.locale })
  }, [router.locale])

  return (
    <ConfigProviderBit locale={antdLocale}>
      <AntdAppBit>
        <Helmet>
          <html className="white" dir={dir} />
          <script src="/cdnstatic/libs/react.v18.3.0.min.js"></script>
          <script src="/cdnstatic/libs/react-dom.v18.3.0.min.js"></script>
        </Helmet>
        <SeoTdk />
        <Resource />
        <Outlet />
        <FloatButton.BackTop className="!bottom-[140px]" />
        <GlobalModal />
      </AntdAppBit>
    </ConfigProviderBit>
  )
}

export default App
